<template>
    <div class="suspects-completed-type-1">
        <div class="content">
            <div class="icon-check-neg pulse-animation"></div>
            <div class="h3 title">{{$t('components.suspects_completed.title')}}</div>
            <div class="p description">{{$t(hasAudience ? 'components.suspects_completed.description_audience' : 'components.suspects_completed.description')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SuspectsCompleted",
    props: {
        hasAudience: {
            type: Boolean,
            default: false
        }
    }
}
</script>